import * as React from 'react';
import styled from '@emotion/styled';

import { Icon } from '@hotjar/webapp/components/Icon';

const BaseBulletStyles = `
  margin-right: .6em;
`;

const Bullet = styled.span`
  width: 0.5em;
  height: 0.5em;
  display: block;
  border-radius: 0.5em;
  background: currentColor;
  margin-top: 0.35em;
  ${BaseBulletStyles}
`;

const StyledIcon = styled(Icon)`
  ${BaseBulletStyles}
  min-width: 1em;
  min-height: 1em;
  margin-top: 0.1em;
`;

const StyledListItem = styled.li`
  line-height: 1.3;
  margin-bottom: 0.8em;
  display: flex;
`;

interface ListItemProps {
  icon?: string;
  iconColor?: string;
  children?: React.ReactNode;
}

export const ListItem = ({ icon, iconColor, children }: ListItemProps): JSX.Element => {
  return (
    <StyledListItem>
      {icon ? <StyledIcon icon={icon} color={iconColor} size="1em" /> : <Bullet />}
      <span>{children}</span>
    </StyledListItem>
  );
};
